import { Popover, Grid } from "@mui/material";
import DefaultIcon, { defaultIcons } from "../../components/common/DefaultIcon";
import { StyledIconButton } from "./commonUi.styles";

interface IconPickerPopoverProps {
    anchorEl: HTMLElement | null;
    colorHex: string;
    selectedIconName: string;
    onSelectIcon: (iconName: string) => void;
    onClose: () => void;
}

const IconPickerPopover = ({
    anchorEl,
    colorHex,
    onSelectIcon,
    onClose
}: IconPickerPopoverProps) => {
    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            sx={{ overflowY: "auto" }}
        >
            <Grid
                container
                spacing={2}
                padding={2}
                sx={{
                    width: "250px",
                    paddingBottom: 1,
                }}
            >
                {defaultIcons.map((icon) => (
                    <Grid item xs={3} key={icon.iconName}>
                        <StyledIconButton
                            onClick={() => {
                                onSelectIcon(icon.iconName);
                                onClose();
                            }}
                        >
                            <DefaultIcon
                                iconName={icon.iconName}
                                colorHex={colorHex}
                                iconUrl={null}
                            />
                        </StyledIconButton>
                    </Grid>
                ))}
            </Grid>
        </Popover>
    );
};

export default IconPickerPopover;
